export default __webpack_public_path__ + "static/media/signature.a5352045.png";